import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import { planningDisplayText } from '../utils/planningDisplayText';

/** Keep planning translations and interpolated numbers consistent. */
export function useAnnualPlanTranslation() {
  const translation = useTranslation();
  const t = useMemo(() => ((...args: Parameters<TFunction>) =>
    planningDisplayText(translation.t(...args), translation.i18n.language)) as TFunction, [translation.t, translation.i18n.language]);
  return { ...translation, t };
}
